<template>
    <div>
        <h1 class="display-heading">{{pageTitle}}</h1>

        <!-- #region Create -->
        <div class="bs-stepper" v-if="isAdd">
            <div class="bs-stepper-header" role="tablist">
                <div class="step" data-target="#search-employee">
                    <button
                        type="button"
                        class="step-trigger"
                        role="tab"
                        aria-controls="search-employee"
                        id="search-employee-trigger"
                    >
                        <span class="bs-stepper-circle">1</span>
                        <span class="bs-stepper-label">Search Employee</span>
                    </button>
                </div>
                <div class="line"></div>
                <div class="step" data-target="#benefits-coverage">
                    <button
                        type="button"
                        class="step-trigger"
                        role="tab"
                        aria-controls="benefits-coverage"
                        id="benefits-coverage-trigger"
                    >
                        <span class="bs-stepper-circle">2</span>
                        <span class="bs-stepper-label"
                            >Benefits Coverage</span
                        >
                    </button>
                </div>
            </div>
            <div class="bs-stepper-content">
                <!-- your steps content here -->
                <div
                    id="search-employee"
                    class="content"
                    role="tabpanel"
                    aria-labelledby="search-employee-trigger"
                >
                    <div class="form-group">
                        <label><b>Employee's Name</b></label>
                        <input type="text" placeholder="Employee's Name" name="employeeName" v-model="searchName" class="form-control">
                        <label><b>Employee's Identification Number</b></label>
                        <input type="text" placeholder="Employee's Identification Number" name="employeeIC" v-model="searchIC" class="form-control">
                        <div v-if="searchError" style="color: red">
                            At least one search field is required!
                        </div>
                    </div>
                    <button
                        @click="searchEmployee()"
                        class="btn btn-primary btn-primary-insv"
                    >
                        Search
                    </button>
                    <div class="table-responsive">
                        <div ref="tableSection">
                            <table ref="listTable" class="table table-hover">
                                <col width="50">
                                <col>
                                <col width="200">
                                <col width="150">
                                <col width="150">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Employee Name</th>
                                        <th scope="col">NRIC</th>
                                        <th scope="col">Tier</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-show="searchResult.length === 0">
                                        <td :colspan="columnsCount" class="text-center font-italic">
                                            {{isTableLoading ? "Loading Data": "No Data"}}
                                        </td>
                                    </tr>
                                    <tr v-for="(employee, index) in searchResult" :key="index">
                                        <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                                        <td>{{employee.name}}</td>
                                        <td>{{employee.nric}}</td>
                                        <td>{{employee.tierName}}</td>
                                        <td>
                                            <button
                                                @click="
                                                    form.ui = employee.userId;
                                                    userId = employee.userId;
                                                    userTier = employee.tierId;
                                                    nextStep();
                                                "
                                                class="btn btn-primary btn-primary-insv"
                                            >
                                                Select
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- <pagination v-model="pagination.currentPage"
                            :totalPages="pagination.totalPages"
                            :scrollPosition="pagination.scrollPosition">
                        </pagination> -->
                    </div>
                </div>

                <div
                    id="benefits-coverage"
                    class="content"
                    role="tabpanel"
                    aria-labelledby="benefits-coverage-trigger"
                >
                    <p><b>Employee Benifit Information</b></p>
                    <div>
                        <employee-benefit-details v-model="employeeBenefitDetail"></employee-benefit-details>

                        <form data-vv-scope="add-manual-reimbursement" @submit.prevent="validateAddForm">
                            <div class="form-group">
                                <label><b>Patient Name</b></label>
                                <select placeholder="Patient" name="patient" v-model="form.pui"
                                    data-vv-as="patient" data-vv-validate-on="blur"
                                    v-validate="'required'" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('add-manual-reimbursement.patient'),
                                    }" @change="updatePatient()">
                                    <option :value="null" disabled hidden>Please Select...</option>
                                    <option :value="form.ui">{{principalName}} (Principal)</option>
                                    <option v-for="(dependent, index) in dependentList" :key="index"
                                        :value="dependent.userId">
                                        {{dependent.fullName}} ({{relationshipTypes.find(r => r.value === dependent.relationship).text}})
                                    </option>
                                </select>
                                <div v-show="validationErrors.has('add-manual-reimbursement.patient')" class="invalid-feedback">
                                    {{ validationErrors.first('add-manual-reimbursement.patient') }}
                                </div>

                                <label><b>Consultation / Transaction Date</b></label>
                                <input type="text" placeholder="DD/MM/YYYY" name="reimbursementDate" v-model="form.rd"
                                    data-vv-as="reimbursement date" data-vv-validate-on="blur" v-mask="'##/##/####'"
                                    v-validate="'required|date_format:DD/MM/YYYY'" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('add-manual-reimbursement.reimbursementDate')
                                    }">
                                <div v-show="validationErrors.has('add-manual-reimbursement.reimbursementDate')" class="invalid-feedback">
                                    {{ validationErrors.first('add-manual-reimbursement.reimbursementDate') }}
                                </div>

                                <label class="mb-0"><b>Reimbursement Amount</b></label>
                                <br>
                                <small>Key in negative value of amount if adding credit balance of employee, spouse or dependents. </small>
                                <input type="number" step=".01" placeholder="0.00" name="reimbursementAmount" v-model="form.a"
                                    data-vv-as="reimbursement amount" data-vv-validate-on="blur"
                                    v-validate="approvedAmountValidation"
                                    :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('add-manual-reimbursement.reimbursementAmount')
                                    }">
                                <div v-show="validationErrors.has('add-manual-reimbursement.reimbursementAmount')" class="invalid-feedback">
                                    {{ validationErrors.first('add-manual-reimbursement.reimbursementAmount') }}
                                </div>

                                <label><b>Remarks</b></label>
                                <!-- <input type="text" placeholder="Remarks" name="remark" v-model="form.r" class="form-control"> -->
                                <textarea placeholder="Remarks" name="remark" v-model="form.r" class="form-control" rows="3"></textarea>
                            </div>
                        </form>
                        <p v-if="shouldShowSubmitMessage"
                            :class="{
                                'text-danger': submitHasError
                            }" v-html="submitMessage">
                        </p>
                    </div>

                    <!-- Back Button -->
                    <button
                        @click="previousStep"
                        class="btn btn-secondary"
                    >
                        Previous
                    </button>

                    <!-- Next Button -->
                    <button
                        @click="save()"
                        class="btn btn-primary btn-primary-insv ml-2"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region Update -->
        <div v-else>
            <employee-benefit-details v-model="employeeBenefitDetail"></employee-benefit-details>

            <form data-vv-scope="update-manual-reimbursement" @submit.prevent="validateUpdateForm">
                <div class="form-group row">
                    <label class="col-sm-3 col-xl-2 col-form-label">Employee Name</label>
                    <div class="col-sm-9 col-xl-10">
                        <input type="text" class="form-control" v-model="userName" disabled="disabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-xl-2 col-form-label">Patient</label>
                    <div class="col-sm-9 col-xl-10">
                        <input type="text" class="form-control" v-model="patientName" disabled="disabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-xl-2 col-form-label">Relationship</label>
                    <div class="col-sm-9 col-xl-10">
                        <input type="text" class="form-control" v-model="relationship" disabled="disabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-xl-2 col-form-label">Uploaded Documents</label>
                    <div class="col-sm-9 col-xl-10">
                        <div v-if="files.length <= 0">No files uploaded.</div>
                        <template v-else>
                            <a v-for="(fileId, index) in files" class="btn btn-primary btn-primary-insv mr-2" :key="index" :href="`${apiPath}ManualReimbursement/DownloadFileById?fileId=${fileId}&token=${token}`" download>Download File {{ index + 1 }}</a>
                        </template>
                    </div>
                    <small class="col">
                        Note: uploaded files will be removed after 1 year
                    </small>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-xl-2 col-form-label">Consultation / Transaction Date</label>
                    <div class="col-sm-9 col-xl-10">
                        <input type="text" class="form-control" v-model="reimbursementDate" disabled="disabled">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-xl-2 col-form-label">Request Amount</label>
                    <div class="col-sm-9 col-xl-10">
                        <input type="text" class="form-control" v-model="requestAmount" disabled="disabled">
                    </div>
                </div>
                <div v-if="status !== getEnumValueByDisplay(genericStatus, 'Pending')" class="form-group row">
                    <label class="col-sm-3 col-xl-2 col-form-label">Status</label>
                    <div class="col-sm-9 col-xl-10">
                        <span class="badge text-nowrap" :class="statusBadgeClass">
                            {{ statusDisplay }}
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-xl-2 col-form-label">Approved Amount</label>
                    <div class="col-sm-9 col-xl-10">
                        <!-- <input type="text" class="form-control" v-model="approvedAmount"> -->
                        <input type="number" step=".01" placeholder="0.00" name="reimbursementAmount" v-model="approvedAmount"
                            data-vv-as="reimbursement amount" data-vv-validate-on="blur"
                            v-validate="approvedAmountValidation" :disabled="status !== getEnumValueByDisplay(genericStatus, 'Pending')"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('update-manual-reimbursement.reimbursementAmount')
                            }">
                        <div v-show="validationErrors.has('update-manual-reimbursement.reimbursementAmount')" class="invalid-feedback">
                            {{ validationErrors.first('update-manual-reimbursement.reimbursementAmount') }} {{ approvedAmountMessage }}
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-xl-2 col-form-label">Remarks</label>
                    <div class="col-sm-9 col-xl-10">
                        <input type="text" class="form-control" v-model="remark" :disabled="status !== getEnumValueByDisplay(genericStatus, 'Pending')">
                    </div>
                </div>
                        <p v-if="shouldShowSubmitMessage"
                            :class="{
                                'text-danger': submitHasError
                            }" v-html="submitMessage">
                        </p>
                <div>
                    <div v-if="status === getEnumValueByDisplay(genericStatus, 'Pending')">
                        <button type="button" class="btn btn-danger btn-danger-insv mr-2 mb-2" @click="reject()">
                            Reject
                        </button>
                        <button type="button" class="btn btn-primary btn-primary-insv mr-2 mb-2" @click="approve()">
                            Approve
                        </button>
                    </div>
                    <div>
                        <a href="#/company/manual-reimbursement" class="btn btn-secondary mb-2 router-link-active">
                            Back to List
                        </a>
                    </div>
                </div>
            </form>
        </div>
        <!-- #endregion -->
    </div>
</template>

<script>
import {
    convertDateToDDMMYYYY,
    convertDateToIso8601
} from '@/utilities';
import { apiPath } from '@/config';
import Cookies from 'js-cookie';
import $ from 'jquery';
import {
    mask
} from 'vue-the-mask';
import popupModal from '@/components/popup-modal';
import permissible from '@/components/permissible';
import EmployeeBenefitDetails from '@/components/employee-benefit-details';
import 'daterangepicker/daterangepicker';
// import _ from 'lodash';
import Stepper from 'bs-stepper';
import {
    genericStatus,
    getEnumDisplay,
    getEnumBadgeClass,
    getEnumValueByDisplay
} from '@/config/enums';
import relationshipTypes from '@/config/relationshipTypes';
export default {
    'name': '',
    'directives': {
        mask
    },
    'components': {
        popupModal,
        permissible,
        EmployeeBenefitDetails
    },
    'computed': {
        manualReimbursementId () {
            return this.$route.name === 'company-manual-reimbursement-detail' ? this.$route.params.id : null;
        },
        isAdd () {
            return this.$route.name === 'company-manual-reimbursement-add';
        },
        pageTitle () {
            return this.isAdd ? 'Add New Reimbursement' : 'View Reimbursement Details';
        },
        shouldShowSubmitMessage () {
            return this.submitMessage ? this.submitMessage.length > 0 : false;
        },
        token () {
            return Cookies.get('t');
        },
        approvedAmountValidation () {
            if (this.relationship == null) {
                return 'required|decimal:2|not_zero';
            } else {
                var annualLimit = 0;
                if (this.employeeBenefitDetail.benefitType === 'Family' || this.relationship === 'Principal') {
                    annualLimit = this.employeeBenefitDetail.companyAnnualLimit - this.employeeBenefitDetail.companyAnnualUsage;
                }
                if (this.employeeBenefitDetail.spouseBenefit && this.relationship === 'Spouse') {
                    annualLimit = this.employeeBenefitDetail.spouseAnnualLimit - this.employeeBenefitDetail.spouseAnnualUsage;
                }
                if (this.employeeBenefitDetail.dependentBenefit && this.relationship === 'Dependent') {
                    annualLimit = this.employeeBenefitDetail.dependentAnnualLimit - this.employeeBenefitDetail.dependentAnnualUsage;
                }

                var maxValue = this.requestAmount;
                this.approvedAmountMessage = 'Cannot exceed request amount. ';
                if (annualLimit < this.requestAmount || this.requestAmount == null) {
                    maxValue = annualLimit;
                    this.approvedAmountMessage = 'Cannot exceed annual limit. ';
                }
                return 'required|decimal:2|not_zero|max_value:' + maxValue;
            }
        }
    },
    mounted () {
        $('[data-toggle="tooltip"]').tooltip();
        this.$validator.extend(
            'not_zero', {
                'getMessage': field => 'The ' + field + ' cannot be zero.',
                'validate': (value) => {
                    // value must be > zero
                    if (parseFloat(value) === 0) return false;
                    return true;
                }
            });
        if (!this.isAdd && this.manualReimbursementId) {
            this.axios.get('ManualReimbursement/GetManualReimbursementDetail', {
                'params': {
                    'manualReimbursementId': this.manualReimbursementId
                }
            }).then(({
                data
            }) => {
                let reimbursementData = data.data;
                this.userId = reimbursementData.ui;
                this.userName = reimbursementData.un;
                this.patientName = reimbursementData.pn;
                this.relationship = relationshipTypes.find(r => r.value === reimbursementData.rs).text;
                this.companyName = reimbursementData.cn;
                this.userTier = reimbursementData.ti;
                this.reimbursementDate = convertDateToDDMMYYYY(reimbursementData.rd);
                this.requestAmount = reimbursementData.ra.toFixed(2);
                this.approvedAmount = reimbursementData.aa.toFixed(2);
                this.status = reimbursementData.s;
                this.remark = getEnumValueByDisplay(genericStatus, 'Pending') === reimbursementData.s || reimbursementData.r ? reimbursementData.r : '-';
                this.files = reimbursementData.f;
                this.statusDisplay = getEnumDisplay(genericStatus, reimbursementData.s);
                this.statusBadgeClass = getEnumBadgeClass(genericStatus, reimbursementData.s);
                this.getTierInfo();
                this.getSpendingInfo();
            }).catch(() => {});
        } else {
            // Setup Stepper
            this.stepper = new Stepper(document.querySelector('.bs-stepper'));
            this.columnsCount = this.$refs.listTable.rows[0].cells.length;
        }
    },
    data () {
        return {
            genericStatus,
            'apiPath': apiPath,
            'form': {
                'mri': null,
                'ui': null,
                'pui': null,
                'rd': null,
                'a': null,
                'r': ''
            },
            'columnsCount': 0,
            'isTableLoading': false,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 40,
                'scrollPosition': 0
            },
            'searchName': null,
            'searchIC': null,
            'searchError': false,
            'searchResult': [],
            'userTier': '',
            'dependentList': [],
            'principalName': '',
            'employeeBenefitDetail': {
                'benefitType': '',
                'companyAnnualLimit': 0,
                'companyMonthlyLimit': 0,
                'companyWeeklyLimit': 0,
                'companyAnnualUsage': 0,
                'companyAnnualUsagePercentage': 0,
                'companyMonthlyUsage': 0,
                'companyMonthlyUsagePercentage': 0,
                'companyWeeklyUsage': 0,
                'companyWeeklyUsagePercentage': 0,
                'spouseBenefit': false,
                'spouseAnnualLimit': 0,
                'spouseAnnualUsage': 0,
                'spouseAnnualUsagePercentage': 0,
                'spouseMonthlyUsage': 0,
                'spouseMonthlyUsagePercentage': 0,
                'spouseWeeklyUsage': 0,
                'spouseWeeklyUsagePercentage': 0,
                'dependentBenefit': false,
                'dependentAnnualLimit': 0,
                'dependentAnnualUsage': 0,
                'dependentAnnualUsagePercentage': 0,
                'dependentMonthlyUsage': 0,
                'dependentMonthlyUsagePercentage': 0,
                'dependentWeeklyUsage': 0,
                'dependentWeeklyUsagePercentage': 0,
                'transactionLimit': {
                    'teleconsultation': '',
                    'teleconsultationApplicable': false,
                    'medicine': '',
                    'medicineApplicable': false,
                    'clinic': '',
                    'clinicApplicable': false
                },
                'supbc': false,
                'dupbc': false,
                'pbc': [],
                'sbc': [],
                'dbc': []
            },
            'userId': null,
            'userName': null,
            'patientName': null,
            'relationship': null,
            'companyName': null,
            'reimbursementDate': null,
            'requestAmount': null,
            'approvedAmount': null,
            'remark': null,
            'status': null,
            'files': [],
            'statusDisplay': '',
            'statusBadgeClass': '',
            'isSaving': false,
            'submitMessage': '',
            'submitHasError': false,
            'approvedAmountMessage': '',
            relationshipTypes
        };
    },
    'methods': {
        async nextStep () {
            this.getTierInfo();
            this.getSpendingInfo();
            this.getDependents();
            this.stepper.next();
        },
        previousStep () {
            this.stepper.previous();
        },
        searchEmployee () {
            if (!this.searchName && !this.searchIC) {
                this.searchError = true;
            } else {
                this.searchError = false;
                this.isTableLoading = true;

                this.axios.post('employeeTier/GetEmployeeList', {
                    'p': this.pagination.currentPage,
                    'ps': this.pagination.pageSize,
                    'fn': this.searchName,
                    'in': this.searchIC,
                    'id': false
                }).then(({ data }) => {
                    this.isTableLoading = false;
                    let pagedResult = data.data;

                    this.pagination.currentPage = pagedResult.p;
                    this.pagination.totalPages = pagedResult.c;

                    let list = pagedResult.l;

                    this.searchResult = list.map((employee) => ({
                        'userId': employee.ui,
                        'name': employee.fn ? employee.fn : '-',
                        'nric': employee.in ? employee.in : '-',
                        'tierId': employee.ti,
                        'tierName': employee.tn,
                        'dependentCount': employee.dc
                    }));
                });
            }
        },
        getTierInfo () {
            this.axios.get('Tier/GetTierDetails', {
                'params': {
                    'tierId': this.userTier
                }
            }).then(({
                data
            }) => {
                let tierData = data.data;
                this.employeeBenefitDetail.supbc = tierData.supbc;
                this.employeeBenefitDetail.dupbc = tierData.dupbc;
                this.employeeBenefitDetail.pbc = tierData.pbc;
                this.employeeBenefitDetail.sbc = tierData.supbc ? tierData.pbc : tierData.sbc;
                this.employeeBenefitDetail.dbc = tierData.dupbc ? tierData.pbc : tierData.dbc;
            }).catch(() => {});
        },
        getSpendingInfo () {
            this.axios.get('CompanyCredit/GetMyCompanyBalance', {
                'params': {
                    'userId': this.userId,
                    'tierId': this.userTier
                }
            }).then(({
                data
            }) => {
                let item = data.data[0];
                this.employeeBenefitDetail.principalName = item.pn;
                this.employeeBenefitDetail.benefitType = item.bt;
                this.employeeBenefitDetail.companyAnnualLimit = item.al;
                this.employeeBenefitDetail.companyMonthlyLimit = item.ml;
                this.employeeBenefitDetail.companyWeeklyLimit = item.wl;
                this.employeeBenefitDetail.companyAnnualUsage = item.au;
                this.employeeBenefitDetail.companyAnnualUsagePercentage = item.au / item.al * 100;
                this.employeeBenefitDetail.companyMonthlyUsage = item.mu;
                this.employeeBenefitDetail.companyMonthlyUsagePercentage = item.mu / item.ml * 100;
                this.employeeBenefitDetail.companyWeeklyUsage = item.wu;
                this.employeeBenefitDetail.companyWeeklyUsagePercentage = item.wu / item.wl * 100;
                this.employeeBenefitDetail.spouseBenefit = item.sb;
                this.employeeBenefitDetail.spouseAnnualLimit = item.sal;
                this.employeeBenefitDetail.spouseAnnualUsage = item.sau;
                this.employeeBenefitDetail.spouseAnnualUsagePercentage = item.sau / item.sal * 100;
                this.employeeBenefitDetail.spouseMonthlyUsage = item.smu;
                this.employeeBenefitDetail.spouseMonthlyUsagePercentage = item.smu / item.ml * 100;
                this.employeeBenefitDetail.spouseWeeklyUsage = item.swu;
                this.employeeBenefitDetail.spouseWeeklyUsagePercentage = item.swu / item.wl * 100;
                this.employeeBenefitDetail.dependentBenefit = item.db;
                this.employeeBenefitDetail.dependentAnnualLimit = item.dal;
                this.employeeBenefitDetail.dependentAnnualUsage = item.dau;
                this.employeeBenefitDetail.dependentAnnualUsagePercentage = item.dau / item.dal * 100;
                this.employeeBenefitDetail.dependentMonthlyUsage = item.dmu;
                this.employeeBenefitDetail.dependentMonthlyUsagePercentage = item.dmu / item.ml * 100;
                this.employeeBenefitDetail.dependentWeeklyUsage = item.dwu;
                this.employeeBenefitDetail.dependentWeeklyUsagePercentage = item.dwu / item.wl * 100;
                this.employeeBenefitDetail.transactionLimit.teleconsultation = item.hctl ? `RM ${item.ectl.toFixed(2)}` : 'N/A';
                this.employeeBenefitDetail.transactionLimit.teleconsultationApplicable = item.hctl ? item.ectl > 0 : false; // do not display if company set the limit to 0
                this.employeeBenefitDetail.transactionLimit.medicine = item.hptl ? `RM ${item.eptl.toFixed(2)}` : 'N/A';
                this.employeeBenefitDetail.transactionLimit.medicineApplicable = item.hptl ? item.eptl > 0 : false; // do not display if company set the limit to 0
                this.employeeBenefitDetail.transactionLimit.clinic = item.hcctl ? `RM ${item.ecctl.toFixed(2)}` : 'N/A';
                this.employeeBenefitDetail.transactionLimit.clinicApplicable = item.hcctl ? item.ecctl > 0 : false; // do not display if company set the limit to 0
            });
        },
        getDependents () {
            this.axios.get('EmployeeTier/GetDependentList', {
                'params': {
                    'userId': this.userId
                }
            }).then(({
                data
            }) => {
                if (data.data) {
                    this.dependentList = data.data.map((dependent) => ({
                        'userId': dependent.ui,
                        'fullName': dependent.fn,
                        'relationship': dependent.r
                    }));
                }
            }).catch(() => {});
        },
        validateAddForm () {
            return this.$validator.validateAll('add-manual-reimbursement');
        },
        validateUpdateForm () {
            return this.$validator.validateAll('update-manual-reimbursement');
        },
        save () {
            this.validateAddForm().then((isValid) => {
                if (isValid) {
                    let tempData = JSON.parse(JSON.stringify(this.form));
                    tempData.rd = convertDateToIso8601(tempData.rd);

                    this.submitHasError = false;
                    this.isSaving = true;
                    this.submitMessage = 'Saving manual reimbursement details...';
                    this.axios.post('ManualReimbursement/CreateCompanyManualReimbursement', tempData)
                        .then(() => {
                            this.submitMessage = 'Record Added!';
                            this.$router.push(
                                {
                                    'name': 'company-manual-reimbursement'
                                });
                        }).catch((error) => {
                            this.submitHasError = true;

                            if (error.response && error.response.data) {
                                this.submitMessage = error.response.data.message;
                            } else {
                                this.submitMessage = 'Error saving reimbursement details... Please try again.';
                            }
                        }).finally(() => {
                            this.isSaving = false;
                        });
                }
            });
        },
        approve () {
            this.validateUpdateForm().then((isValid) => {
                if (isValid) {
                    let tempData = {
                        'mri': this.manualReimbursementId,
                        'a': this.approvedAmount,
                        'r': this.remark
                    };
                    this.submitHasError = false;
                    this.isSaving = true;
                    this.submitMessage = 'Updating manual reimbursement details...';
                    this.axios.post('ManualReimbursement/ApproveUserManualReimbursement', tempData)
                        .then(() => {
                            this.submitMessage = 'Request approved!';
                            this.$router.push(
                                {
                                    'name': 'company-manual-reimbursement'
                                });
                        }).catch((error) => {
                            this.submitHasError = true;

                            if (error.response && error.response.data) {
                                this.submitMessage = error.response.data.message;
                            } else {
                                this.submitMessage = 'Error updating reimbursement details... Please try again.';
                            }
                        }).finally(() => {
                            this.isSaving = false;
                        });
                }
            });
        },
        reject () {
            let tempData = {
                'mri': this.manualReimbursementId,
                'r': this.remark
            };
            this.submitHasError = false;
            this.isSaving = true;
            this.submitMessage = 'Updating manual reimbursement details...';
            this.axios.post('ManualReimbursement/RejectUserManualReimbursement', tempData)
                .then(() => {
                    this.submitMessage = 'Request rejected!';
                    this.$router.push(
                        {
                            'name': 'company-manual-reimbursement'
                        });
                }).catch((error) => {
                    this.submitHasError = true;

                    if (error.response && error.response.data) {
                        this.submitMessage = error.response.data.message;
                    } else {
                        this.submitMessage = 'Error updating reimbursement details... Please try again.';
                    }
                }).finally(() => {
                    this.isSaving = false;
                });
        },
        updatePatient () {
            var patient = this.dependentList.find(d => d.userId === this.form.pui);
            var relationship = 0;
            if (patient != null) {
                relationship = patient.relationship;
            }

            this.relationship = relationshipTypes.find(r => r.value === relationship).text;
        },
        getEnumValueByDisplay
    },
    'watch': {
        'form.hfl': function (value) {
            this.form.sb = value;
            this.form.db = value;
        }
    }
};

</script>

<style scoped>
.active .bs-stepper-circle {
    background-color: #009344;
}

.bs-stepper .step-trigger:focus {
  color: #009344;
  outline: none;
}
</style>
